import axios from 'axios';

const BACKEND_URL = import.meta.env.VITE_API_URL || 'https://api.findteacher.co.za';


export const api = axios.create({
  baseURL: `${BACKEND_URL}/api`,
  headers: {
    'Content-Type': 'application/json',
  },
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('adminToken');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export const adminLogin = (email, password) => api.post('/admin/login', { email, password });

// Admin Stats
export const getAdminStats = () => api.get('/admin/stats');

// Teachers
export const getTeachers = () => api.get('/teachers');
export const updateTeacherStatus = (teacherId, active) =>
  api.put(`/admin/teachers/${teacherId}/status?active=${active}`);
export const verifyTeacher = (teacherId, verified) =>
  api.put(`/admin/teachers/${teacherId}/verify?verified=${verified}`);

// Students
export const getStudents = () => api.get('/students');
export const updateStudentStatus = (studentId, active) =>
  api.put(`/admin/students/${studentId}/status?active=${active}`);

// Bookings
export const getBookings = () => api.get('/bookings');

// Withdrawals
export const getWithdrawals = () => api.get('/admin/withdrawals');
export const getPendingWithdrawalsCount = () => api.get('/admin/withdrawals/pending');
export const approveWithdrawal = (transactionId) =>
  api.put(`/admin/withdrawals/${transactionId}/approve`);
export const rejectWithdrawal = (transactionId, reason = '') =>
  api.put(`/admin/withdrawals/${transactionId}/reject?reason=${encodeURIComponent(reason)}`);
